import {
  APP_INITIALIZER,
  ApplicationConfig,
  LOCALE_ID,
  /* inject, provideAppInitializer, */ provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { provideRouter, withPreloading, PreloadAllModules } from "@angular/router";
import { routes } from "./app.routes";
import { providePrimeNG } from "primeng/config";
import { provideAnimations } from "@angular/platform-browser/animations";
import { AiraPreset } from "./core/themes/aira.preset";
import { AppConfigService, AuthService } from "./core/services";
import { apiEnvelopeErrorInterceptor } from "./core/interceptors/api-envelope-error.interceptor";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { httpErrorInterceptor } from "./core/interceptors/http-error.interceptor";
import { captchaInterceptor } from "./core/interceptors/captcha.interceptor";
import { cacheInterceptor } from "./core/interceptors/cache.interceptor";
import { MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { LOGIN_REPOSITORY_TOKEN } from "./core/repositories/tokens/repository.tokens";
import { LoginHttpRepository } from "./core/repositories/http/login-http.repository";
import {
  SELECTABLE_CLIENT_ASSIGNMENTS_REPOSITORY_TOKEN,
} from "./shared/repositories/tokens";
import {
  SelectableClientAssignmentsHttpRepository,
} from "./shared/repositories/http";
import { APPROVAL_ACH_RECEIPTS_REPOSITORY_TOKEN } from "./features/admin/approval-ach-receipts/repositories/tokens/repository.tokens";
import { ApprovalAchReceiptsHttpRepository } from "./features/admin/approval-ach-receipts/repositories/http/approval-ach-receipts-http.repository";
import { SHOPPING_CART_REPOSITORY_TOKEN } from "./features/user/cart/repositories/tokens/repository.tokens";
import { ShoppingCartHttpRepository } from "./features/user/cart/repositories/http/shopping-cart-http.repository";
import { EMPTY_CART_REPOSITORY_TOKEN } from "./features/admin/empty-cart/repositories/tokens/repository.tokens";
import { EmptyCartHttpRepository } from "./features/admin/empty-cart/repositories/http/empty-cart-http.repository";
import { SERVICE_PAYMENT_REPOSITORY_TOKEN } from "./features/user/service-operations/repositories/tokens/repository.tokens";
import { ServicePaymentHttpRepository } from "./features/user/service-operations/repositories/http/service-payment-http.repository";

/** Arranque: api, branding y features viven en `src/environments` y se leen vía AppConfigService. */
function initAppConfig(configService: AppConfigService) {
  return () => configService.loadConfig();
}

// Register Spanish locale
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: "es" },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: initAppConfig,
      deps: [AppConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (authService: AuthService) => () => authService.checkAuth(),
      deps: [AuthService],
      multi: true,
    },
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([
        captchaInterceptor,
        //cacheInterceptor, // Cachear respuestas GET antes de authInterceptor (comentado por estar en estado de prueba)
        authInterceptor,
        apiEnvelopeErrorInterceptor,
        httpErrorInterceptor,
      ]),
      withFetch(),
    ),
    providePrimeNG({
      theme: {
        preset: AiraPreset,
        options: {
          darkModeSelector: ".dark",
        },
      },
      overlayAppendTo: "body",
    }),
    {
      provide: MessageService,
    },
    {
      provide: DialogService,
    },
    {
      provide: LOGIN_REPOSITORY_TOKEN,
      useClass: LoginHttpRepository,
    },
    {
      provide: SELECTABLE_CLIENT_ASSIGNMENTS_REPOSITORY_TOKEN,
      useClass: SelectableClientAssignmentsHttpRepository,
    },
    {
      provide: APPROVAL_ACH_RECEIPTS_REPOSITORY_TOKEN,
      useClass: ApprovalAchReceiptsHttpRepository,
    },
    {
      provide: SHOPPING_CART_REPOSITORY_TOKEN,
      useClass: ShoppingCartHttpRepository,
    },
    {
      provide: EMPTY_CART_REPOSITORY_TOKEN,
      useClass: EmptyCartHttpRepository,
    },
    {
      provide: SERVICE_PAYMENT_REPOSITORY_TOKEN,
      useClass: ServicePaymentHttpRepository,
    },
  ],
};
